export const environment = {
    production: false,
    apiUrl: "https://kalpitatech-api-dev.azurewebsites.net/api/",
    apiUrl1: "https://kalpitatech-api-dev.azurewebsites.net/api/",
    apiKey: "KC-DEV-a7f3e9b1c4d8f2a6e0b5d9c3f7a1e4b8",
    // production: true,
    //apiUrl: "https://kalpitademo.azurewebsites.net/api/",
   
     googleRecaptchaSiteKey:
     '6Ldt3a4UAAAAAOWbjKNKym7S6i4bSxo8JQT4gKMa',
     GA_TRACKING_ID: 'G-DK4K1XZ8PT'
  };
